import { TagContainer } from '../models/container';
import { getEvents } from '../models/helpers';
import { PopinAuthShowed } from '@app/core/user/store/actions';

const events = getEvents((action: PopinAuthShowed) => [
  {
    type: 'pageview',
    container: TagContainer.Analytics,
    payload: {
      event: 'pageView',
      pageUrl:
        '/popin/' +
        (action.payload.forced ? 'forced' : 'asked') +
        '/' +
        'version2' +
        (action.payload.isMobile ? 'mobile' : '') +
        '/' +
        action.payload.type
    }
  }
]);

export default events;
